"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollbarGlobalStyle = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var Axis = /*#__PURE__*/function (Axis) {
  Axis["Horizontal"] = "Horizontal";
  Axis["Vertical"] = "Vertical";
  return Axis;
}(Axis || {});
// We could consider moving the scrollbar style to a global style if we also want it to propagate down through libraries or other implementations that use overflow: auto or overflow: scroll
var scrollbarGlobalStyle = exports.scrollbarGlobalStyle = (0, _styledComponents.css)(["scrollbar-color:auto;scrollbar-width:", ";"], function (_ref) {
  var isPageScroller = _ref.isPageScroller;
  return isPageScroller ? 'auto' : 'thin';
});
var ScrollbarStyle = _styledComponents.default.div.withConfig({
  displayName: "Scrollbar__ScrollbarStyle",
  componentId: "sc-jrmf2v-0"
})(["flex:1 1 auto;overflow:auto;", " ", " ", ""], function (_ref2) {
  var hideAxis = _ref2.hideAxis;
  return hideAxis === Axis.Horizontal ? (0, _styledComponents.css)(["overflow-x:hidden;"]) : hideAxis === Axis.Vertical ? (0, _styledComponents.css)(["overflow-y:hidden;"]) : null;
}, function (_ref3) {
  var maxHeight = _ref3.maxHeight;
  return maxHeight && (0, _styledComponents.css)(["max-height:", "px;"], maxHeight);
}, scrollbarGlobalStyle);
/**
 * Scrollbar implementation using a styled native scrollbar rather than pushing the native scroll out of view and displaying a custom element
 *
 * Note that in order for the overflow: auto property to work properly, the Scrollbar either needs the immediate parent to have overflow: hidden, or to have a fixed maxHeight.
 */
var Scrollbar = function Scrollbar(_ref4) {
  var _ref4$hasFocusableCon = _ref4.hasFocusableContent,
    hasFocusableContent = _ref4$hasFocusableCon === void 0 ? false : _ref4$hasFocusableCon,
    hideAxis = _ref4.hideAxis,
    maxHeight = _ref4.maxHeight,
    isPageScroller = _ref4.isPageScroller,
    onScroll = _ref4.onScroll,
    children = _ref4.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ScrollbarStyle, {
    className: "scrollbar",
    maxHeight: maxHeight,
    hideAxis: hideAxis,
    onScroll: onScroll,
    isPageScroller: isPageScroller,
    tabIndex: hasFocusableContent ? undefined : 0,
    children: children
  });
};
Scrollbar.Axis = Axis;
var _default = exports.default = Scrollbar;